<template>
	<div>
		<el-dialog v-model="dialogTableVisible" :show-close="false" title="查看图片" top="4vh" width="60%" :close-on-click-modal='false' :close-on-press-escape='false'>
			<template #header>
				<el-row>
					<el-col :span="22" v-if="select_info">
						<el-row>
							<el-col :span="24" style="margin-top:20px">
								<div class="goodDetails_name_title" style="">
									<span class="content">
										型号：{{img_title.model}}
									</span>
									<span class="content">
										订货号：{{img_title.order_no}}
									</span>
									<span class="content">
										数量：{{img_title.sur_num}}
									</span>
									<span class="content">
									</span>
									<span class="content" v-if="select_info" style="float: right;">
										<el-button type="danger" style="color:#fff;margin-right: 0.75rem;" @click="del">删除</el-button>
										<el-select style="width: 10rem" v-model="img_title.stock_type_txt">
											<el-option v-for="item in stocktype_list" :key="item.name" :label="item.name" :value="item.name" />
										</el-select>
										<el-button color="#ff8a5c" :loading="loading" style="color:#fff;margin-left: 0.75rem;" @click="updateStorckType">保存</el-button>
										<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="$emit('cutImg', this.img_title.index+1,1)">下一个产品</el-button>
									</span>
								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="22" v-else>
						<div class="goodDetails_name_title" style="">
							<span class="top">
								查看图片
							</span>
							<span class="content">
								型号：{{img_title.model}}
							</span>
							<span class="content">
								订货号：{{img_title.order_no}}
							</span>
							<span class="content">
								数量：{{img_title.sur_num}}
							</span>
						</div>
					</el-col>
					<el-col :span="2" style="text-align:right" class="Share_Close">
						<el-icon size="18px" @click="showShare_click" v-if="share_info">
							<Share />
						</el-icon>
						<el-icon size="18px" style="margin-left:10px" @click="dialogTableVisible=false">
							<Close />
						</el-icon>
					</el-col>
				</el-row>
			</template>
			<el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
				<el-tab-pane label="当前详情" name="img">
					<div class="goodDetails_name_img">
						<div class="goodDetails_name_img_div" style="height:60vh">
							<el-image :src="imgBigUrl" style="width: 100%;height: 100%" :preview-src-list="data" :zoom-rate="1.2" :initial-index="idx">
								<template #error>
									<div style="padding: 25% 45%;">
										暂无图片
									</div>
								</template>
							</el-image>
						</div>
						
					</div>
				</el-tab-pane>
				<el-tab-pane label="疑似关联" name="list">
					<template #label>
						
						<span v-if="img_title.associate.length">
							<el-badge :max="10000000" :value="img_title.associate.length" class="item">
							<span>疑似关联</span>
						</el-badge>
						</span>
						<span v-else>
							<span>疑似关联</span>
						</span>
					</template>
					<div class="associate-publish-wrapper">
							<div class="associate-table">
								<!-- 表头 -->
								<div class="associate-table-header">
								<div class="th col-type"></div>
								<div class="th col-status">货物状态</div>
								<div class="th col-brand">品牌</div>
								<div class="th col-model">型号</div>
								<div class="th col-orderno">订货号</div>
								<div class="th col-price">面价</div>
								<div class="th col-discount">折扣</div>
								<div class="th col-estimate">脱手单价</div>
								<div class="th col-action">操作</div>
							</div>
								<!-- 主商品固定数据 -->
							<div class="associate-table-row main-row">
								<div class="td col-type"><span class="tag-main">脱手商品</span></div>
								<div class="td col-status">
									<div class="stock_type_txt_button">
										<span v-for="(item, idx) in (img_title.stock_type_txt ? img_title.stock_type_txt.split('、') : [])" :key="idx">
											<el-button class="A" size="small" text bg v-if="item == '二手' || item == '过保' || item == '包附破损'">{{ item }}</el-button>
											<el-button class="C" size="small" text bg v-else color="#ff8a5c">{{ item }}</el-button>
										</span>
									</div>
								</div>
								<div class="td col-brand">
										<el-input v-model="img_title.brand_name" disabled size="small" placeholder="" />
									</div>
									<div class="td col-model">
										<el-input v-model="img_title.model" disabled size="small" placeholder="" />
									</div>
									<div class="td col-orderno">
										<el-input v-model="img_title.order_no" disabled size="small" placeholder="" />
									</div>
									<div class="td col-price">
										<el-input v-model="img_title.tsw_price_" disabled size="small" placeholder="" />
									</div>
									<div class="td col-discount"><el-input v-model="img_title.tsw_price_" disabled size="small" placeholder="" /></div>
									<div class="td col-estimate"><el-input v-model="img_title.tsw_price" disabled size="small" placeholder="" /></div>
									<div class="td col-action">
										<el-icon :size="22" color="rgb(82, 155, 46)" @click="add_associate">
											<CirclePlusFilled />
										</el-icon>
									</div>
								</div>
							</div>
							<!-- 疑似关联列表表头 -->
							<div class="associate-table associate-table-suspect">
								<div class="associate-table-header">
									<div class="th col-type"></div>
									<div class="th col-status">货物状态</div>
									<div class="th col-brand">品牌</div>
									<div class="th col-model">型号</div>
									<div class="th col-orderno">订货号</div>
									<div class="th col-price">面价</div>
									<div class="th col-discount">折扣</div>
									<div class="th col-estimate">市场估价</div>
									<div class="th col-action">操作</div>
								</div>
							</div>
							<!-- 疑似关联列表（可滚动） -->
							<el-scrollbar height="54vh" always="true">
								<div class="associate-cards">
									<div class="associate-card" v-for="(item,index) in img_title.associate" :key="index">
										<div class="associate-card-row">
										<div class="td col-type"><span class="tag-associate">疑似关联</span></div>
										<div class="td col-status"><span class="stock-tag">全新</span></div>
										<div class="td col-brand">
												<el-input v-model="item.brand_name" size="small" placeholder="请输入品牌" />
											</div>
											<div class="td col-model col-model-action">
										<el-input v-model="item.model" size="small" placeholder="请输入型号" />
										<el-icon size="18" class="more-action"
											style="color: #29afa5; position: absolute; right: 4px; top: 50%; transform: translateY(-50%);"
											@click="dialogTableVisible_goods_show(item, index)">
											<MoreFilled />
										</el-icon>
									</div>
											<div class="td col-orderno">
												<el-input v-model="item.order_no" size="small" placeholder="请输入订货号" />
											</div>
											<div class="td col-price">
												<el-input v-model="item.price" size="small" placeholder="请输入面价" @input="inputBlur_price(index, item)" />
											</div>
											<div class="td col-discount">
												<el-input v-model="item.discount" size="small" placeholder="请输入折扣" @input="inputBlur_discount(index, item)" />
											</div>
											<div class="td col-estimate">
												<el-input v-model="item.real_price" size="small" placeholder="请输入市场估价" @input="inputBlur_real_price(index, item)" />
											</div>
											<div class="td col-action">
												<el-icon :size="22" color="red" @click="del_associate(index)">
													<CircleCloseFilled />
												</el-icon>
											</div>
										</div>
										<div class="associate-card-remark">
											<el-input v-model="item.remark" type="textarea" :rows="3" placeholder="请输入备注" />
										</div>
									</div>
								</div>
							</el-scrollbar>
						</div>
					
				</el-tab-pane>
			</el-tabs>
			<div class="goodDetails_name_img">
						
						<el-row>
							<el-col :xs="7" :sm="5" :md="5" :lg="3" :xl="3" v-if="cutImg_info" style="margin-top: 2.5rem;">
								<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="$emit('cutImg', this.img_title.index-1,1)">上一个产品</el-button>
							</el-col>
							<el-col :xs="cutImg_info?10:24" :sm="cutImg_info?14:24" :md="cutImg_info?14:24" :lg="cutImg_info?18:24" :xl="cutImg_info?18:24">
								<div class="little_img">
									<span v-for="(item, index) in data" :key="index" @mouseenter="getUrl(item, index)">
										<img :src="item">
									</span>
								</div>
							</el-col>
							<el-col :xs="7" :sm="5" :md="5" :lg="3" :xl="3" v-if="cutImg_info && !select_info" style="margin-top: 2.5rem;">
								<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="$emit('cutImg', this.img_title.index+1,1)">下一个产品</el-button>
							</el-col>
						</el-row>
					</div>
		</el-dialog>
		<el-dialog title="分享" v-model="showShare" width="40%" :close-on-click-modal='false' :close-on-press-escape='false'>
			<el-form :model="shareForm">
				<el-form-item label="分享标题">
					<el-input placeholder="请输入分享标题" class="shareInp" v-model="shareForm.title"></el-input>
				</el-form-item>
				<!-- <el-form-item label="一口总价">
          <el-input placeholder="请输入一口总价" class="shareInp" v-model="shareForm.price"></el-input>
        </el-form-item> -->
				<el-form-item label="货主备注">
					<el-input placeholder="请输入您的联系方式，地址等" class="shareInp" type="textarea" :rows="3" v-model="shareForm.remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" style="text-align:right">
				<el-button @click="cancleShare" class="cancle_btn">取 消</el-button>
				<el-button class="set_btn" @click="sureShare">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="分享" :close-on-click-modal="false" v-model="showqr" width="250">
			<div id="qrcode" style="text-align:center">
				<qrcode-vue :value="QRCodeVue_text" v-if="QRCodeVue_text" :size="200" level="H" />
			</div>
			<div class="qrText" style="text-align:center">分享至微信朋友圈</div>
		</el-dialog>
		<!-- 调入商品库弹窗 -->
		<el-dialog v-model="dialogTableVisible_goods" v-if="dialogTableVisible_goods" title="调入商品库" width="95%"
			:close-on-click-modal='false' :close-on-press-escape='false'>
			<el-row :gutter="20">
				<el-col :span="18">
					<el-col :span="24">
						<el-table @row-click="particulars_goods_rowClick" :row-style="particulars_goods_addStyle"
							:row-class-name="particulars_goods_tableRowClassName" @row-dblclick="rowDblclickGoods"
							:data="particulars_goods_tableData" height="50vh"
							v-loading="particulars_goods_loading" :header-cell-style="{ 'background-color': '#e5e5e5' }"
							size="small" style="width: 100%">
							<el-table-column prop="brand_name" label="品牌" width="120" show-overflow-tooltip />
							<el-table-column prop="name" label="品名" width="" show-overflow-tooltip />
							<el-table-column prop="model" label="型号" width="" show-overflow-tooltip />
							<el-table-column prop="order_no" label="订货号" width="" show-overflow-tooltip />
							<el-table-column prop="price" label="列表价" width="120" show-overflow-tooltip />
							<el-table-column prop="product_time" width="120" label="列表价年份" show-overflow-tooltip />
						</el-table>
					</el-col>
					<el-col :span="24" class="page" style="display: flex; justify-content: flex-end; margin-top: 10px;">
						<el-pagination :pager-count="5" size="small" class="pagination"
							:current-page="particulars_goods_page" background :page-size="particulars_goods_page_size"
							layout="prev, pager, next" @current-change="particulars_goods_handleCurrentChange"
							:total="particulars_goods_total">
						</el-pagination>
					</el-col>
				</el-col>
				<el-col :span="6">
					<div class="search_box_enq">
						<div class="empty" @click="empty">清空</div>
						<table class="search_tab" border="1" cellspacing="0" cellpadding="0" bordercolor="#e6e6e6" style="width: 100%;">
							<tr>
								<td align="right" style="width: 80px;">品牌：</td>
								<td>
									<el-input v-model="search_val.brand_name" @keyup.enter.native="particulars_goods_search"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right">系列：</td>
								<td>
									<el-input v-model="search_val.series" @keyup.enter.native="particulars_goods_search"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right">品名：</td>
								<td>
									<el-input v-model="search_val.name" @keyup.enter.native="particulars_goods_search"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right">型号：</td>
								<td>
									<el-input v-model="search_val.model" @keyup.enter.native="particulars_goods_search"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right">订货号：</td>
								<td>
									<el-input v-model="search_val.order_no" @keyup.enter.native="particulars_goods_search"></el-input>
								</td>
							</tr>
						</table>
						<div style="margin-top: 10px;">
							<el-button class="green_btn" @click="particulars_goods_in">引用</el-button>
							<el-button class="green_btn" @click="particulars_goods_search">查询</el-button>
						</div>
					</div>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { MoreFilled } from '@element-plus/icons-vue'
export default {
	name: '',
	components: {
		MoreFilled
	},
	data() {

		return {
			loading:false,
			associate:[],
			input: '',
			activeName: 'img',
			select_info: false,
			stocktype_list: [{
					id: 'A',
					name: '滞纳、在保、包附完好'
				},
				{
					id: 'B',
					name: '滞纳、在保、包附破损'
				},
				{
					id: 'C',
					name: '滞纳、过保、包附完好'
				},
				{
					id: 'D',
					name: '滞纳、过保、包附破损'
				},
				{
					id: 'E',
					name: '二手、在保、包附完好'
				},
				{
					id: 'F',
					name: '二手、在保、包附破损'
				},
				{
					id: 'G',
					name: '二手、过保、包附完好'
				},
				{
					id: 'H',
					name: '二手、过保、包附破损'
				}
			],
			QRCodeVue_text: '',
			shareForm: {},
			imgBigUrl: '',
			idx: 0,
			showqr: false,
			dialogTableVisible: false,
			showShare: false,
			share_info: true,
			cutImg_info: false,
			data: [],
			img_title: { model: '', order_no: '', sur_num: '', name: '' },
			// 调入商品库弹窗相关
			dialogTableVisible_goods: false,
			search_val: {},
			goods_data: {},
			associate_goods_index: -1,
			particulars_goods_tableData: [],
			particulars_goods_loading: false,
			particulars_goods_total: 0,
			particulars_goods_page: 1,
			particulars_goods_page_size: 120,
			particulars_goods_index: [],
		}
	},
	props: [],

	updated() {

	},

	watch: {

	},
	mounted() {

	},

	activated() {

	},
	created() {

	},

	methods: {
		/**
		 * 打开调入商品库弹窗（疑似关联卡片：型号列的三个点图标）
		 * @param {Object} item 当前疑似关联项
		 * @param {Number} index 当前疑似关联项索引
		 */
		dialogTableVisible_goods_show(item, index) {
			this.dialogTableVisible_goods = true;
			this.goods_data = item;
			this.associate_goods_index = index;
			this.particulars_goods_page = 1;
			// 初始化搜索条件，使用当前关联项字段作为默认值
			this.search_val = {
				
				order_no: item.order_no || ''
			};
			this.particulars_goods_search();
		},
		/**
		 * 商品库分页切换
		 */
		particulars_goods_handleCurrentChange(val) {
			this.particulars_goods_page = val;
			this.particulars_goods_search();
		},
		/**
		 * 清空搜索条件
		 */
		empty() {
			this.search_val = {};
		},
		/**
		 * 查询商品库列表
		 */
		async particulars_goods_search() {
			this.particulars_goods_index = [];
			this.particulars_goods_loading = true;
			var search = this.search_val || {};
			search.page = this.particulars_goods_page;
			search.ps = this.particulars_goods_page_size;
			await this.$axios.post('/api/yunsys.storage/getbaseproductprice', search).then(async (res) => {
				var res = res.data;
				this.particulars_goods_loading = false;
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true
					})
				}
				this.particulars_goods_total = res.data.total;
				this.particulars_goods_tableData = res.data.data;
			})
				.catch(err => {
					this.particulars_goods_loading = false;
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true
					})
				})
		},
		/**
		 * 商品行单击：高亮选中行
		 */
		particulars_goods_rowClick(row) {
			this.particulars_goods_index = [parseInt(row.index)]
		},
		/**
		 * 表格行样式：选中行背景高亮
		 */
		particulars_goods_addStyle({ row, rowIndex }) {
			if (this.particulars_goods_index.indexOf(rowIndex) > -1) {
				return { 'background-color': '#ecf5ff' }
			}
		},
		/**
		 * 表格行 className：给每行注入 index 属性
		 */
		particulars_goods_tableRowClassName({ row, rowIndex }) {
			row.index = rowIndex
			return ''
		},
		/**
		 * 使用选中行填充当前疑似关联项（引用按钮）
		 */
		particulars_goods_in() {
			if (this.particulars_goods_index.length > 0) {
				var sel = this.particulars_goods_tableData[this.particulars_goods_index[0]];
				this.applyGoodsToAssociate(sel);
				this.dialogTableVisible_goods = false;
			} else {
				return ElMessage({
					message: '请选择数据！',
					type: 'error',
					grouping: true
				})
			}
		},
		/**
		 * 商品行双击：直接填充
		 */
		rowDblclickGoods(row) {
			this.applyGoodsToAssociate(row);
			this.dialogTableVisible_goods = false;
		},
		/**
		 * 将选中的商品基础信息回填到疑似关联项，并重新计算市场估价
		 * @param {Object} sel 商品库选中的行数据
		 */
		applyGoodsToAssociate(sel) {
			if (!sel || this.associate_goods_index < 0 || !this.img_title.associate) return;
			var item = this.img_title.associate[this.associate_goods_index];
			if (!item) return;
			item.brand_name = sel.brand_name || '';
			item.name = sel.name || '';
			item.model = sel.model || '';
			item.order_no = sel.order_no || '';
			item.series = sel.series || '';
			item.price = sel.price || '';
			// 重新计算市场估价 real_price = price × discount（若无折扣则保持原值）
			this.calcRealPrice(item);
			// 同步回写到数组以确保响应式更新
			this.img_title.associate.splice(this.associate_goods_index, 1, JSON.parse(JSON.stringify(item)));
		},
		del_associate(index){
			this.img_title.associate.splice(index, 1)
		},
		add_associate(){
			this.img_title.associate.push({
				brand_name:'', model:'', order_no:'', remark:'',
				price:  '', real_price: '', discount: '',
			})
		},
		inputBlur_price(index, item) {
			item.price = this.clearNoNum(item.price, 2)
			this.calcRealPrice(item)
		},
		inputBlur_discount(index, item) {
			item.discount = this.clearNoNum(item.discount, 2)
			this.calcRealPrice(item)
		},
		inputBlur_real_price(index, item) {
			item.real_price = this.clearNoNum(item.real_price, 2)
			if (item.price && Number(item.price) > 0) {
				item.discount = this.$bn.divide(item.real_price, item.price, 2)
			}else{
				item.discount = 0.00
			}
		},
		calcRealPrice(item) {
			if (item.price && Number(item.price) > 0 && item.discount && Number(item.discount) > 0) {
				item.real_price = this.$bn.multiply(item.price, item.discount, 2)
			}else{
				item.real_price = 0.00
			}
		},
		clearNoNum(value, decimals) {
			//先把非数字的都替换掉，除了数字和.
			value = (value || '').replace(/[^\d.]/g, "");
			//保证只有出现一个.而没有多个.
			value = value.replace(/\.{2,}/g, ".");
			//必须保证第一个为数字而不是.
			value = value.replace(/^\./g, "");
			//保证.只出现一次，而不能出现两次以上
			value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			//只能输入指定小数位
			return value.replace(eval("/^(\\-)*(\\d+)\\.(\\d{1," + decimals + "}).*$/"), '$1$2.$3')
		},
		handleClick() {

		},
		del() {
			ElMessageBox.confirm(
					'确认删除此数据，不可恢复！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {

					this.del_ajax()
				})
				.catch(() => {

				})

		},
		async del_ajax() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/deletestorage', { ids: [this.img_title.id] }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.$emit('cutImg', this.img_title.index, 1, true)
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async updateStorckType() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/updateoneinfo', { stock_type_txt: this.img_title.stock_type_txt, id: this.img_title.id,associate:this.img_title.associate }).then(async (res) => {
				this.loading = false
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					//需要修改外面列表的货物状态
					this.$emit('stockTypeTxtSave', this.img_title);
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})


				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})

		},
		getUrl(url, idx) {
			this.imgBigUrl = url
			this.idx = idx

		},
		cancleShare() {
			this.showShare = false
			this.shareForm = {}
		},
		async showShare_click() {
			await this.$axios.post('/api/yunsys.Website/getnameandtel', this.shareForm).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.shareForm.title = this.img_title.brand_name + ' ' + this.img_title.name + ' ' + this.img_title.model + ' 数量:' + this.img_title.num;
					this.shareForm.remark = res.data.linkman + res.data.mobile;
					this.showShare = true

				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		// 确认分享
		async sureShare() {
			if (!this.shareForm.title) {
				return ElMessage({
					message: '请填写分享标题',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			this.shareForm.id = [this.img_title.id]
			await this.$axios.post('/api/yunsys.storage/share', this.shareForm).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.QRCodeVue_text = res.data.url

					this.$nextTick(function() {
						this.showqr = true
						this.showShare = false
						this.shareForm = {}

					})
					/*return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})*/

				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})


		},
	}
}
</script>
<style lang="less" scoped>
:deep(.content .el-select) {
	width: 220px;
}

:deep(.el-button > span) {
	margin-right: 0px;
}

.goodDetails_name_title {
	line-height: 34px;
	overflow: hidden;
	white-space: nowrap;
}

.Share_Close {
	line-height: 34px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

:deep(.el-tabs__nav-scroll) {
	padding-left: 0px !important;
}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
	:deep(.el-dialog){
		width:80% !important;
	}
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
	:deep(.el-dialog){
		width:80% !important;
	}
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
	:deep(.el-dialog){
		width:70% !important;
	}
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
	:deep(.el-dialog){
		width:60% !important;
	}
}

:deep(.el-tabs__item.is-active) {
	// background-color: #f56c6c; /* 选中标签的背景颜色 */
	//border-color: #f56c6c; /* 选中标签的边框颜色 */
	color: #ff8a5c;
	/* 选中标签的文字颜色 */
}
:deep(.el-tabs__active-bar) {
	background-color: #ff8a5c;
	/* 选中标签下方的横线颜色 */
}
:deep(.el-input-group__append) {
	background: #ff8a5c;
}

/* ========== 疑似关联编辑表格样式 ========== */
.associate-publish-wrapper {
	width: 100%;
}

.associate-table {
	border: 1px solid #ebeef5;
	border-radius: 6px;
	overflow: hidden;
	font-size: 13px;
	background: #fff;
	box-sizing: border-box;
}

.associate-table-header {
	display: flex;
	background: #f5f7fa;
	color: #606266;
	font-weight: 600;
}

.associate-table-header .th,
.associate-table-row .td,
.associate-card-row .td {
	text-align: center;
	border-right: 1px solid #ebeef5;
	box-sizing: border-box;
	position: relative;
}

/* 表头上下内边距 */
.associate-table-header .th {
	padding: 4px 4px;
}

.associate-table-header .th:last-child,
.associate-table-row .td:last-child,
.associate-card-row .td:last-child {
	border-right: none;
}

.associate-table-row,
.associate-card-row {
	display: flex;
	align-items: center;
}

.associate-table-row {
	border-top: 1px solid #ebeef5;
}

.associate-table-row.main-row {
	background: #f5f7fa;
}

/* ========== 列宽定义（总和 100%） ========== */
.col-type { width: 8%; }
.col-status { width: 17%; }
.col-brand { width: 15%; }
.col-model { width: 18%; }
.col-orderno { width: 18%; }
.col-price { width: 7%; }
.col-discount { width: 5%; }
.col-estimate { width: 6%; }
.col-action { width: 6%; }

/* ========== 标签样式 ========== */
.tag-main {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 600;
	white-space: nowrap;
}

.tag-associate {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 600;
	white-space: nowrap;
}

/* ========== 货物状态样式（参考 img.vue） ========== */
.stock_type_txt_button {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 3px;
}

:deep(.associate-table .stock_type_txt_button .el-button > span) {
	margin-right: 0;
}

.stock-tag {
	display: inline-block;
	padding: 2px 8px;
	background: #f0f9eb;
	color: #67c23a;
	border-radius: 10px;
	font-size: 12px;
	font-weight: 500;
}

/* 疑似关联列表独立表头：仅保留顶部圆角与边框，底部开放 */
.associate-table-suspect {
	border-radius: 6px 6px 0 0;
	margin-top: 10px;
	border-bottom: none;
}

/* ========== 疑似关联卡片 ========== */
.associate-cards {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.associate-card {
	background: #fff;
	border: 1px solid #ebeef5;
	border-radius: 6px;
	overflow: hidden;
}

.associate-card-remark {
	border-top: 1px dashed #ebeef5;
	background: #fafafa;
}

.associate-table .el-icon,
.associate-card .el-icon {
	cursor: pointer;
}

/* 隐藏编辑区域的 el-input 边框并增高 */
:deep(.associate-table .el-input__wrapper),
:deep(.associate-card .el-input__wrapper) {
	box-shadow: none !important;
	border-radius: 0;
	min-height: 34px;
}

/* 禁用输入框聚焦时的边框 */
:deep(.associate-table .el-input__wrapper.is-focus),
:deep(.associate-card .el-input__wrapper.is-focus),
:deep(.associate-table .el-input__wrapper.is-hover),
:deep(.associate-card .el-input__wrapper.is-hover) {
	box-shadow: none !important;
}

/* textarea 边框隐藏 */
:deep(.associate-table .el-textarea__inner),
:deep(.associate-card .el-textarea__inner) {
	border: none !important;
	box-shadow: none !important;
}

/* 型号列"..."按钮浮动在右侧，输入框留出空间 */
:deep(.col-model-action .el-input__wrapper) {
	padding-right: 28px;
}

.more-action {
	cursor: pointer;
	z-index: 2;
}

/* 调入商品库搜索框样式（与 publish.vue 视觉一致） */
.search_box_enq .empty {
	text-align: right;
	margin-bottom: 6px;
	font-size: 12px;
	color: #909399;
	cursor: pointer;
}

.search_box_enq .search_tab td {
	font-size: 13px;
}
</style>